import { SupportedMessageFormats, ConnectionNames } from "../../contracts";
import { RequestFormatter, JSON_RPC, ConfigStore } from "../../common";
import { STR_ERRORS } from "../strings";
import { SDQuerySubscribersStore } from "../SDQuerySubscribersStore";
export function SDQRequestFormatter(query) {
    const id = SDQuerySubscribersStore.getQueryID(query);
    let message;
    if (query.name === "unsubscribe") {
        message = RequestFormatter({
            type: SupportedMessageFormats[JSON_RPC],
            channel: query.name,
            data: {},
            id: query.params["id"] || ""
        }, ConnectionNames.sports);
    }
    else {
        if (typeof id === "undefined") {
            throw new Error(STR_ERRORS.SDQRequestFormatRequiresActiveQuery);
        }
        message = RequestFormatter({
            type: SupportedMessageFormats[JSON_RPC],
            channel: query.name,
            data: Object.assign(Object.assign({}, query.params), { jwt: ConfigStore.config.connections.jwt || "", siteName: ConfigStore.config.siteName }),
            id
        }, ConnectionNames.sports);
    }
    return message;
}
//# sourceMappingURL=SDQRequestFormatter.js.map